export default {
  id: 'imagine.pairing.ReselectAssetPair',
  type: 'imagine.pairing.ReselectAssetPair',
  perform: context => {
    const {
      setActiveStep,
      onChange
    } = context;
    onChange({
      data: 'asset',
      value: null
    });
    setActiveStep('selectPairAsset');
  }
};